export default __webpack_public_path__ + "static/media/easton fluted panel.26a026c2.png";